<template>
  <div class="i-user-multi-picker">
    <div class="field-label">
      {{ label }}
    </div>
    <multiselect
      ref="multi"
      v-model="selected"
      label="name"
      trackBy="userId"
      :options="users"
      :multiple="false"
      :placeholder="placeholder"
      :disabled="disabledPicker"
      @search-change="onSearchChange"
      @select="onSelect"
      @remove="onRemove"
      @open="onOpen"
      @keydown.native="onKeydown"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listOnlyUsers as listMicrosoftUsers} from "@/services/api/app/seat-management/user";
import {listAllUsers} from "@/services/api/app/office/recovery/exchange/exchange";
import {list as listGoogleUsers} from "@/services/api/app/google/seat-management/user"
import {list as listDropboxUsers} from "@/services/api/app/dropbox/seat-management/user";
import {list as listBoxUsers} from "@/services/api/app/box/seat-management/user";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'IUserPicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: 'Users'
    },
    placeholder: {
      type: String,
      default: 'Search for users here'
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    },
    providerTenant: {
      type: String,
      default: 'MICROSOFT'
    },
    currentCollection: {
      type: String,
      default: ''
    },
    disabledPicker: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: null,
      users: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.users = [];
      this.loadUsers(searchTerm)
    },
    loadUsers(search = null) {
      let list = listGoogleUsers
      if (this.providerTenant === 'MICROSOFT') {
        if (this.currentCollection === 'exchange') {
          list = listAllUsers;
        } else if (this.currentCollection == 'oneDrive') {
          list = listMicrosoftUsers;
        }
      } else if (this.providerTenant === 'DROPBOX') {
        list = listDropboxUsers
      } else if (this.providerTenant === 'BOX') {
        list = listBoxUsers
      }

      list({
        pagination: {
          ...defaultPagination(),
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.users = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    },
    onSearchChange() {
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView);
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView);
      }
    },
    scrollHighlightedIntoView() {
      const multi = this.$refs.multi;
      if (!multi || !multi.$el) return;

      const wrapper = multi.$el.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;

      const highlighted = wrapper.querySelector('.multiselect__option--highlight');
      if (highlighted) {
        highlighted.scrollIntoView({block: 'nearest'});
      }
    },
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadUsers();
  },
}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
